import React, { useEffect } from 'react';
import { styled } from '@nykaa/ui-components';
import MicroIcon from '@nykaa/ui-components/Icons/microphone';
import { hexToRgb } from '@nykaa/ui-components/styles/utils';
import useMicrophone from 'hooks/voiceSearch';
import { MicroPhoneProps } from 'types/voiceSearch';
import { noop } from '../../constants';
import { trackVoiceSearchSupport } from 'helpers/voiceSearch';
import { useIsConfigHeader, useIsThemeHeader } from 'hooks/header';
import { getSvgFillColor } from 'components/Header/helper';

const Wrapper = styled.button<{ isThemeHeader: boolean; color?: string }>`
  height: 40px;
  width: 40px;
  background: ${({ theme }) => hexToRgb(theme.colors.primary, 0.08)};
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  margin-left: ${({ theme }) => theme.spacing.spacing40};
  border: none;
  cursor: pointer;
  svg path {
    fill: ${({ isThemeHeader, color, theme: { colors } }) =>
      getSvgFillColor(isThemeHeader, color, colors)};
  }
`;

const MicroPhone = ({ handleMicrophone = noop }: MicroPhoneProps) => {
  const { support } = useMicrophone();
  const isThemeHeader = useIsThemeHeader();
  const { headerTextColor } = useIsConfigHeader();

  useEffect(() => {
    trackVoiceSearchSupport(support);
  }, [support]);

  if (!support) {
    return null;
  }

  return (
    <Wrapper
      onClick={handleMicrophone}
      isThemeHeader={isThemeHeader}
      color={headerTextColor}
    >
      <MicroIcon size="22px" />
    </Wrapper>
  );
};

export default MicroPhone;
